 import React from 'react'
 
 function CustomerDebitNoteList() {
   return (
     <div>CustomerDebitNoteList</div>
   )
 }
 
 export default CustomerDebitNoteList